export default function SocialUsd() {
  return (
    <div
      className="ion-icon-social-usd"
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve">
<g>
	<path d="M411.387,303.256c-3.119-9.577-7.891-18.561-14.301-26.952c-6.422-8.382-14.396-15.826-23.93-22.331
		c-9.539-6.498-20.721-11.63-33.553-15.4c-5.143-1.363-14.189-3.506-26.104-6.418c-8.516-2.074-16.5-4.2-25.5-6.367V120.065
		c9,2.396,15.252,6.202,21.926,10.43c14.279,9.04,23.232,24.505,25.855,45.505h69.174c-0.654-18-4.65-32.76-11.996-46.02
		c-8.07-14.543-18.977-27.024-32.73-36.956c-13.75-9.922-30.225-17.49-48.377-22.455C303.967,68.416,297,66.605,288,65.386V32h-64
		v33.167c-7,1.044-15.148,2.445-22.426,4.25c-17.242,4.283-32.388,10.868-45.951,19.764c-13.571,8.905-24.352,20.112-32.604,33.627
		c-8.251,13.523-12.312,29.52-12.312,48c0,9.585,1.407,18.993,4.157,28.235c2.752,9.241,7.442,17.967,14.042,26.181
		c6.603,8.214,15.495,15.658,26.687,22.332c11.183,6.672,24.705,12.064,41.576,16.171c9.287,2.345,18.83,4.534,26.83,6.576v119.586
		c-11-2.919-21.889-7.399-30.678-13.479c-9.17-6.327-16.066-13.953-21.198-23.884c-4.779-9.229-7.073-20.526-7.407-32.526H96
		c0.695,21,5.25,39.494,13.672,55.371c8.799,16.604,20.533,29.96,35.204,40.562c14.662,10.613,31.393,18.356,51.198,23.491
		c8.885,2.304,18.926,3.96,27.926,5.23V480h64v-34.54c10-1.069,18.957-2.69,28.527-4.879c18.701-4.273,35.645-11.036,50.316-20.276
		c14.662-9.24,26.621-21.128,35.611-35.681c8.98-14.541,13.545-32.085,13.545-52.619C416,322.427,414.498,312.841,411.387,303.256z
		 M224,209.699c-12-3.743-23.912-9.088-32.051-16.048c-8.621-7.355-12.673-17.534-12.673-30.545c0-9.241,2.414-16.94,7.004-23.102
		c4.58-6.161,9.912-11.038,16.88-14.631c6.18-3.189,13.84-5.565,20.84-7.138V209.699z M342.902,359.471
		c-2.939,6.673-7.699,12.576-14.303,17.711c-6.602,5.133-15.744,9.328-26.377,12.577c-4.5,1.378-8.223,2.444-14.223,3.236v-107.11
		c10,2.624,18.18,5.332,26.326,8.131c8.062,2.744,15.748,7.443,22.537,14.116c6.785,6.676,10.309,17.03,10.309,31.06
		C347.172,346.042,345.834,352.797,342.902,359.471z"/>
</g>
</svg>
`,
      }}
    />
  )
}
